const FailedIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="cancel">
        <mask
          id="mask0_1764_44726"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="4"
          width="20"
          height="20"
        >
          <rect id="Bounding box" y="4" width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_1764_44726)">
          <path
            id="cancel_2"
            d="M12 12.8166L14.7016 15.5182C14.8233 15.6399 14.958 15.6985 15.1057 15.694C15.2533 15.6895 15.3908 15.6236 15.5182 15.4962C15.6455 15.3688 15.7092 15.2327 15.7092 15.0879C15.7092 14.9431 15.6455 14.8073 15.5182 14.6806L12.8166 11.989L15.5182 9.29742C15.6399 9.17634 15.7022 9.04197 15.705 8.89432C15.7078 8.74669 15.6455 8.60919 15.5182 8.48184C15.3908 8.35447 15.2547 8.29078 15.1099 8.29078C14.9651 8.29078 14.829 8.35447 14.7016 8.48184L12 11.1834L9.29837 8.48184C9.17665 8.36011 9.04563 8.29784 8.90531 8.29502C8.765 8.2922 8.63117 8.35447 8.50381 8.48184C8.37644 8.60919 8.31276 8.74528 8.31276 8.8901C8.31276 9.03492 8.37581 9.17101 8.5019 9.29837L11.1834 12L8.48184 14.7016C8.36011 14.8233 8.3015 14.9544 8.30601 15.0947C8.31051 15.235 8.37644 15.3688 8.50381 15.4962C8.63117 15.6236 8.76726 15.6872 8.91208 15.6872C9.0569 15.6872 9.19236 15.6242 9.31845 15.4981L12 12.8166ZM12.0075 20C10.907 20 9.87051 19.7918 8.89808 19.3754C7.92564 18.959 7.07448 18.386 6.34462 17.6565C5.61474 16.9269 5.0415 16.0765 4.6249 15.1051C4.2083 14.1337 4 13.0958 4 11.9914C4 10.887 4.20821 9.85219 4.62462 8.88709C5.04103 7.92197 5.614 7.07449 6.34352 6.34462C7.07306 5.61475 7.92352 5.04151 8.89489 4.6249C9.86627 4.2083 10.9042 4 12.0086 4C13.113 4 14.1478 4.20821 15.1129 4.62462C16.078 5.04103 16.9255 5.614 17.6554 6.34352C18.3853 7.07306 18.9585 7.92181 19.3751 8.88975C19.7917 9.85769 20 10.8919 20 11.9925C20 13.093 19.7918 14.1295 19.3754 15.1019C18.959 16.0744 18.386 16.9255 17.6565 17.6554C16.9269 18.3853 16.0782 18.9585 15.1103 19.3751C14.1423 19.7917 13.1081 20 12.0075 20Z"
            fill="#D41919"
          />
        </g>
      </g>
    </svg>
  );
};

export default FailedIcon;
